// extracted by mini-css-extract-plugin
module.exports = {"secondFold":"secondFold_secondFold__MyLXW","containerDiv":"secondFold_containerDiv__YrEwj"};